import { useNavigate } from "react-router-dom";
import Index from "./Index";

// v2 — bumped to re-trigger the welcome tour after onboarding visual refresh.
const WELCOME_SEEN_KEY = "fitaura.welcome.seen.v2";

export const markWelcomeSeen = () => {
  try {
    localStorage.setItem(WELCOME_SEEN_KEY, "1");
  } catch {
    /* private mode — non-fatal */
  }
};

export const hasSeenWelcome = (): boolean => {
  try {
    return localStorage.getItem(WELCOME_SEEN_KEY) === "1";
  } catch {
    return false;
  }
};

/**
 * Native-app welcome tour. Shows the same marketing landing page that web
 * users see at /, but with the auth-redirect disabled and a sticky "Continue
 * to Setup" CTA pinned to the bottom. Plays once per install (localStorage),
 * then hands off to /onboarding.
 */
const Welcome = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    markWelcomeSeen();
    navigate("/onboarding", { replace: true });
  };

  return <Index embedded onContinue={handleContinue} />;
};

export default Welcome;
